module.exports = __webpack_public_path__ + "static/img/img.e152c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/img.png
// module id = nuuQ
// module chunks = 30